import { render } from "./FooterIntelNew.vue?vue&type=template&id=33d8eaa2&scoped=true"
import script from "./FooterIntelNew.vue?vue&type=script&lang=js"
export * from "./FooterIntelNew.vue?vue&type=script&lang=js"

import "./FooterIntelNew.vue?vue&type=style&index=0&id=33d8eaa2&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d8eaa2"]])

export default __exports__